export const loader = async () => {
  return null
}

export const SubscriptionBranchMypageSkip: React.FC = () => {
  return <div>TODO</div>
}
